<template>
    <v-row style="user-select: none" justify="center" class="pa-5 px-md-10">
        <v-col md="3">
            <v-card class="pa-4">
                <div class="pa-4" v-if="merchantDetails.qr_base64">
                    <v-img aspect-ratio="1" :src="`data:image/png;base64,${merchantDetails.qr_base64}`" alt="QR Code"></v-img>
                </div>
                <h3 class="text-center">{{ merchantDetails.name || '-' }}</h3>
                <p class="font-weight-light text-center">{{ merchantDetails.mobile || '-' | formatMobileNumber }}</p>
                <div class="mt-8">
                    <!-- <send-qr-form></send-qr-form> -->
                    <SendQRForm v-bind="sendQRFormDialog" @close="sendQRFormDialog = { ...sendQRFormDialog, show: false, data: {} }" />
                    <v-btn color="primary" class="mb-3" @click="sendQR" block depressed>
                        <v-icon left>mdi-email-outline</v-icon>
                        Send QR
                    </v-btn>
                    <v-menu transition="slide-y-transition" bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="fiord" :class="[{ disabled: isDisabledDownloadButton }, 'mb-3 white--text']" v-bind="attrs" v-on="on" block depressed>
                                <v-icon left>mdi-tray-arrow-down</v-icon>
                                Download QR
                            </v-btn>
                            <!-- <v-btn color="#A0A9B3" dark v-bind="attrs" v-on="on" block> Slide Y Transition </v-btn> -->
                        </template>
                        <v-list>
                            <v-list-item @click="downloadMerchantQR('partner')">Download {{ merchantDetails.classification == 'BRANCH' ? 'Branch' : 'Partner' }} QR only</v-list-item>
                            <v-list-item @click="downloadMerchantQR('partner-branches')">Download Partner &amp; Branches QR</v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn @click="printMerchantQR" color="fiord" class="mb-3 white--text" block depressed>
                        <v-icon left>mdi-printer</v-icon>
                        Print QR
                    </v-btn>
                </div>
            </v-card>
        </v-col>
        <v-col md="9" class="pr-md-0">
            <div class="rounded-lg white pa-8">
                <h3 class="mb-10">{{ merchantDetails.classification === 'BRANCH' ? 'Branch' : 'Merchant' }} Information</h3>
                <v-row>
                    <v-col cols="12" class="py-0">
                        <label for="store_name" class="font-weight-medium">{{ merchantDetails.classification === 'BRANCH' ? 'Branch' : 'Merchant' }} Name</label>
                        <h3 class="pb-3">{{ merchantDetails.name || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label for="mobile_number" class="font-weight-medium">UUID</label>
                        <h3 class="pb-3">{{ merchantDetails.uuid || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label for="mobile_number" class="font-weight-medium">Mobile Number</label>
                        <h3 class="pb-3">{{ merchantDetails.mobile || '-' }}</h3>
                    </v-col>

                    <v-col md="12" class="py-0">
                        <label class="font-weight-medium">Merchant Address</label>
                        <h3 class="pb-3">{{ merchantDetails.address || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label for="mobile_number" class="font-weight-medium">Municipality</label>
                        <h3 class="pb-3">{{ merchantDetails.municipality || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label for="mobile_number" class="font-weight-medium">Province</label>
                        <h3 class="pb-3">{{ merchantDetails.province || '-' }}</h3>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Location</label>
                        <h3 class="pb-3">{{ merchantDetails.location || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">
                            Minimum Points Required
                            <v-tooltip bottom max-width="300px">
                                <template v-slot:activator="{ on }">
                                    <v-icon class="ml-2" v-on="on" small>mdi-alert-circle-outline</v-icon>
                                </template>

                                <div class="tooltip-wrapper">
                                    <span>Minimum points required to avail the rewards or promotion.</span>
                                </div>
                            </v-tooltip>
                        </label>
                        <h3 class="pb-3">{{ merchantDetails.min_points || '-' }}</h3>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Type</label>
                        <h3 class="pb-3">{{ merchantDetails.type || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Classification</label>
                        <h3 class="pb-3">{{ merchantDetails.classification || '-' | uppercaseFirst }}</h3>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Longitude</label>
                        <h3 class="pb-3">{{ merchantDetails.longitude || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Latitude</label>
                        <h3 class="pb-3">{{ merchantDetails.latitude || '-' }}</h3>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Primary Merchant (if Branch)</label>
                        <h3 class="pb-3">{{ (merchantDetails.primary_merchant || {}).name || 'N/A' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Batch Number</label>
                        <h3 class="pb-3">{{ merchantDetails.batch_number || '-' }}</h3>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Partner</label>
                        <h3 class="pb-3">{{ merchantDetails.partner || '-' }}</h3>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <label class="font-weight-medium">Enrollment Date</label>
                        <h3 class="pb-3">{{ merchantDetails.created_at || '-' | formatDate(2) }}</h3>
                    </v-col>

                    <v-col cols="12" md="3" class="py-0">
                        <label class="font-weight-medium">Status</label>
                        <div class="mt-2 mb-7">
                            <span class="rounded font-weight-medium text-caption py-2 px-5" :class="['status', merchantDetails.status.toLowerCase()]">
                                {{ merchantDetails.status || '-' | uppercaseFirst }}
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <div class="white rounded-lg px-8 py-4 mt-7" v-if="showActivationSetting">
                <v-row align="center" justify="center" class="text-center">
                    <v-col cols="12"><h3 class="mb-0 text-left font-weight-bold">Activation Setting</h3></v-col>
                </v-row>
                <template v-if="merchantDetails.activate_at">
                    <v-row align="center" justify="center">
                        <v-col md="9" class="pt-0">
                            <div class="my-1 text-body-2">The scheduled activation will be on</div>
                            <v-icon color="#8492A6" left>mdi-calendar-range</v-icon>
                            <span class="font-weight-bold">{{ merchantDetails.activate_at | formatDate(1) }}</span>
                        </v-col>
                        <v-col md="3" class="pt-0">
                            <v-btn
                                class="py-5"
                                @click="
                                    confirmAction({
                                        action: 'cancel-activation',
                                        data: merchantDetails
                                    })
                                "
                                block
                                outlined
                                small
                                text
                            >
                                Cancel Activation
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-row align="center" justify="center" class="text-center">
                        <v-col cols="12" class="py-3">
                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="activate.activate_at" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-row>
                                        <v-col md="9" class="py-0">
                                            <v-radio-group class="my-0" v-model="activate.activate_setting" hide-details row>
                                                <v-radio label="Now" value="NOW"></v-radio>
                                                <v-radio label="Specify Date" value="BY_DATE"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col md="3" class="py-0 pb-3">
                                            <v-btn
                                                class="white--text px-8"
                                                color="success"
                                                @click="
                                                    confirmAction({
                                                        action: 'activate',
                                                        data: merchantDetails
                                                    })
                                                "
                                                block
                                                depressed
                                                :disabled="checkDisable(menu1, activate, 'activate')"
                                            >
                                                Activate
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6" class="py-0" v-show="activate.activate_setting === 'BY_DATE'">
                                            <v-text-field
                                                class="py-3"
                                                label="Date of Activation"
                                                v-model="activate.activate_at"
                                                append-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                v-on:click:append="menu1 = true"
                                                solo
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </template>
                                <v-date-picker v-model="activate.activate_at" :min="minDate" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                    <v-btn text color="primary" :class="{ 'disable-events': isLoading }" @click="$refs.menu1.save(activate.activate_at)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </template>
            </div>

            <div class="white rounded-lg px-8 py-4 mt-7" v-if="showDeactivationSetting">
                <v-row align="center" justify="center" class="text-center">
                    <v-col cols="12"><h3 class="mb-0 text-left font-weight-bold">Deactivation Setting</h3></v-col>
                </v-row>
                <template v-if="merchantDetails.deactivate_setting != 'MANUAL'">
                    <v-row align="center" justify="center">
                        <v-col md="9" class="pt-0">
                            <div class="my-1 text-body-2">The scheduled deactivation will be on</div>
                            <v-icon color="#8492A6" left>mdi-calendar-range</v-icon>
                            <span class="font-weight-bold">{{ deactivate.deactivate_at | formatDate(1, deactivate.deactivate_setting == 'BY_DURATION' ? true : false) }}</span>
                        </v-col>
                        <v-col md="3" class="pt-0">
                            <v-btn
                                class="py-5"
                                @click="
                                    confirmAction({
                                        action: 'cancel-deactivation',
                                        data: merchantDetails
                                    })
                                "
                                outlined
                                text
                                small
                                block
                            >
                                Cancel Deactivation
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-row align="center" justify="center" class="text-center">
                        <v-col cols="12" class="py-3">
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="deactivate.deactivate_at" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-row>
                                        <v-col md="9" class="py-0">
                                            <v-radio-group class="my-0" v-model="deactivate.deactivate_setting" hide-details row>
                                                <v-radio label="Now" value="NOW" v-if="merchantDetails.status.toLowerCase() == 'active'"></v-radio>
                                                <v-radio :disabled="checkMerchantDetailsStatus(merchantDetails.activate_at, merchantDetails.status)" label="Specify Date" value="BY_DATE"></v-radio>
                                                <v-radio
                                                    :disabled="checkMerchantDetailsStatus(merchantDetails.activate_at, merchantDetails.status)"
                                                    v-if="$moment(merchantDetails.activate_at).format('YYYY-MM-DD') === minDate || merchantDetails.status === 'ACTIVE'"
                                                    label="Specify Duration"
                                                    value="BY_DURATION"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col md="3" class="py-0 pb-3">
                                            <v-btn
                                                class="white--text px-8 py-5"
                                                color="error"
                                                @click="
                                                    confirmAction({
                                                        action: 'deactivate',
                                                        data: merchantDetails
                                                    })
                                                "
                                                block
                                                depressed
                                                :disabled="checkDisable(menu2, deactivate, 'deactivate')"
                                            >
                                                Deactivate
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="6" class="py-0" v-show="deactivate.deactivate_setting === 'BY_DATE'">
                                            <v-text-field
                                                :disabled="checkMerchantDetailsStatus(merchantDetails.activate_at, merchantDetails.status)"
                                                class="py-3"
                                                label="Date of Deactivation"
                                                v-model="deactivate.deactivate_at"
                                                append-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                v-on:click:append="menu2 = true"
                                                solo
                                            ></v-text-field>
                                        </v-col>
                                        <v-row v-show="deactivate.deactivate_setting === 'BY_DURATION'">
                                            <v-col md="4">
                                                <v-text-field
                                                    @keypress="$validate.numbersOnly"
                                                    @paste.prevent
                                                    id="durationVal"
                                                    :class="['mt-3', { 'is-invalid': errors.deactivate_duration }]"
                                                    :disabled="checkMerchantDetailsStatus(merchantDetails.activate_at, merchantDetails.status)"
                                                    :error-messages="errors.deactivate_duration"
                                                    v-model="deactivate.deactivate_duration"
                                                    type="number"
                                                    class="mt-3"
                                                    solo
                                                    dense
                                                    min="1"
                                                    @paste="filterPasteAcceptPositive"
                                                ></v-text-field
                                            ></v-col>
                                            <v-col md="4"
                                                ><v-select
                                                    id="durationUnit"
                                                    :disabled="checkMerchantDetailsStatus(merchantDetails.activate_at, merchantDetails.status)"
                                                    v-model="deactivate.deactivate_duration_unit"
                                                    :items="durationItems"
                                                    label="Select unit..."
                                                    class="mt-3"
                                                    solo
                                                    dense
                                                ></v-select
                                            ></v-col>
                                        </v-row>
                                    </v-row>
                                </template>
                                <v-date-picker v-model="deactivate.deactivate_at" :min="getMinDateByActivationDate" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                    <v-btn text color="primary" :class="{ 'disable-events': isLoading }" @click="$refs.menu2.save(deactivate.deactivate_at)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </v-col>

        <AppModal :confirm-dialog="confirmDialog" :confirm-status-loading="confirmStatusLoading" @modalAction="modalAction" />
    </v-row>
</template>

<script>
import SendQRForm from '@/components/Core/SendQrForm.vue';
import AppModal from '@/components/Core/AppModal.vue';

export default {
    name: 'QRDetails',
    components: {
        SendQRForm,
        AppModal
    },
    data() {
        return {
            activeTab: '',
            activate_at: '',
            deactivate_at: '',
            activation: 'immediate',
            deactivation: 'manual',
            activeStyle: ['white', 'rounded', 'pa-1'],
            inactiveStyle: 'btn-inactive',
            menu: false,
            menu1: false,
            menu2: false,
            isLoading: false,
            durationItems: [
                {
                    text: 'Hours',
                    value: 'HOURS'
                },
                {
                    text: 'Days',
                    value: 'DAYS'
                },
                {
                    text: 'Months',
                    value: 'MONTHS'
                },
                {
                    text: 'Years',
                    value: 'YEARS'
                }
            ],
            activate: {
                activate_setting: 'NOW',
                activate_at: ''
            },
            deactivate: {
                deactivate_setting: 'NOW',
                deactivate_at: '',
                deactivate_duration: '',
                deactivate_duration_unit: ''
            },
            sendQRFormDialog: { show: false, action: '', data: {} },
            confirmDialog: { show: false, action: '', data: {}, status: '' },
            confirmStatusLoading: false,
            minDate: this.$moment().add(1, 'd').format('YYYY-MM-DD')
        };
    },
    computed: {
        action() {
            return this.$route.params.action;
        },
        merchantDetails() {
            return { status: '', ...this.$store.getters['merchants/getMerchantDetails'] };
        },

        updateSettingsForm() {
            const data = this.$store.getters['merchants/getNewMerchantDetails'];
            return data || {};
        },

        AImmediateClass() {
            if (this.activation === 'immediate') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        ASchedClass() {
            if (this.activation === 'scheduled') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        DManualClass() {
            if (this.deactivation === 'manual') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        DSchedClass() {
            if (this.deactivation === 'scheduled') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        getMinDateByActivationDate() {
            // if (this.merchantDetails.activate_at === null) return null;
            if (!this.merchantDetails.activate_at) return this.minDate;
            let c = this.$moment(this.merchantDetails.activate_at);
            c = c.add(1, 'd').format('YYYY-MM-DD');
            return c;
        },
        isDisabledDownloadButton() {
            return this.$cookies.get('asyncTaskIDPoll') && this.$cookies.get('asyncTaskIDPoll') != null;
        },
        showActivationSetting() {
            return this.showSettings && ['deactivated', 'inactive'].includes(this.merchantDetails.status.toLowerCase());
        },

        showDeactivationSetting() {
            return this.showSettings && ['active', 'inactive'].includes(this.merchantDetails.status.toLowerCase());
        },

        showSettings() {
            return this.$route.name != 'my-qr';
        }
    },
    watch: {
        merchantDetails(value) {
            // Reset toggle setting
            this.toggleSetting('activate', 'immediate');
            this.toggleSetting('deactivate', 'manual');

            // Activation Setting
            if (value.activate_at) {
                this.activation = 'scheduled';
                this.activate_at = this.$moment(value.activate_at).format('YYYY-MM-DD');
            }

            // Deactivation Setting
            if (value.deactivate_setting == 'MANUAL') {
                this.deactivate.deactivate_setting = 'NOW';
            } else {
                this.deactivation = 'scheduled';
                this.deactivate.deactivate_setting = value.deactivate_setting;

                if (value.deactivate_setting == 'BY_DATE') {
                    this.deactivate.deactivate_at = this.$moment(value.deactivate_at).format('YYYY-MM-DD');
                } else if (value.deactivate_setting == 'BY_DURATION') {
                    this.deactivate.deactivate_at = value.deactivate_at;
                    this.deactivate.deactivate_duration = value.deactivate_duration;
                    this.deactivate.deactivate_duration_unit = value.deactivate_duration_unit;
                }
            }
        }
    },
    methods: {
        toggleSetting(type, val) {
            switch (type) {
                case 'activate':
                    if (val === 'immediate') {
                        this.activation = 'immediate';
                        this.activate_at = '';
                        this.menu1 = false;
                    } else {
                        this.activation = 'scheduled';
                    }
                    break;
                case 'deactivate':
                    if (val === 'manual') {
                        this.deactivation = 'manual';
                        this.deactivate.deactivate_setting = 'MANUAL';
                        this.deactivate.deactivate_at = '';
                        this.deactivate.deactivate_duration = '';
                        this.deactivate.deactivate_duration_unit = '';
                        this.menu2 = false;
                    } else {
                        this.deactivate.deactivate_setting = 'BY_DATE';
                        this.deactivation = 'scheduled';
                    }
                    break;
            }
        },
        // Modal confirmation
        confirmAction({ action, data }) {
            let classification = this.merchantDetails.classification == 'BRANCH' ? 'branch' : 'merchant';
            switch (action) {
                case 'activate':
                    data.modalTitle = `Are you sure you want to activate ${classification} ${this.merchantDetails.name}?`;
                    data.modalDescription = `Activating will enable this ${classification} account.`;
                    this.confirmDialog = { show: true, action, data: { ...data, is_active: true } };
                    break;
                case 'deactivate':
                    data.modalTitle = `Are you sure you want to deactivate ${classification} ${this.merchantDetails.name}?`;
                    data.modalDescription = `Deactivating will disable this ${classification} account.`;
                    this.confirmDialog = { show: true, action, data: { ...data, is_active: false } };
                    break;
                case 'cancel-activation':
                    data.modalTitle = `Are you sure you want to cancel activation of ${classification} ${this.merchantDetails.name}?`;
                    data.modalDescription = 'This will cancel the scheduled activation.';
                    this.confirmDialog = { show: true, proceed: 'Proceed', action, data };
                    break;
                case 'cancel-deactivation':
                    data.modalTitle = `Are you sure you want to cancel deactivation of ${classification} ${this.merchantDetails.name}?`;
                    data.modalDescription = 'This will cancel the scheduled deactivation.';
                    this.confirmDialog = { show: true, proceed: 'Proceed', action, data };
                    break;
            }
        },
        // Exec modal action
        modalAction({ action }) {
            switch (action) {
                case 'activate':
                    if (this.activate.activate_setting == 'NOW') {
                        this.activateHandler();
                    } else {
                        this.updateMerchant('activate');
                    }
                    break;

                case 'deactivate':
                    this.deactivateHandler();
                    break;

                case 'cancel-deactivation':
                    this.deactivate = {
                        deactivate_at: '',
                        deactivate_setting: 'MANUAL'
                    };
                    this.updateMerchant('deactivate');
                    break;

                case 'cancel-activation':
                    this.activate.activate_at = '';
                    this.updateMerchant('activate');

                    if (this.merchantDetails.deactivate_setting != 'MANUAL') {
                        this.deactivate = {
                            deactivate_at: '',
                            deactivate_setting: 'MANUAL'
                        };
                        this.updateMerchant('deactivate');
                    }

                    break;

                case 'cancel':
                    this.confirmDialog.show = false;
                    break;
            }
        },
        updateSettings() {
            if (this.merchantDetails.status === 'DEACTIVATED') {
                // console.log(this.activate);
            } else if (this.merchantDetails.status === 'ACTIVE') {
                // console.log(this.deactivate);
                this.deactivateHandler();
            }
        },
        activateHandler() {
            this.$store
                .dispatch('merchants/activateMerchant', { id: this.merchantDetails.uuid })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message || response[0] });
                    this.confirmDialog.show = false;
                    this.confirmStatusLoading = false;
                    this.fetchMerchant(response.data);
                })
                .catch(() => {
                    this.confirmStatusLoading = false;
                });
        },
        deactivateHandler() {
            const handler = {
                NOW: () => {
                    this.confirmStatusLoading = true;
                    this.$store
                        .dispatch('merchants/deactivateMerchant', { id: this.merchantDetails.uuid })
                        .then((response) => {
                            this.notification({ type: 'success', message: response.message || response[0] });
                            this.confirmDialog.show = false;
                            this.confirmStatusLoading = false;
                            this.fetchMerchant(response.data);
                        })
                        .catch(() => {
                            this.confirmStatusLoading = false;
                        });
                },
                BY_DATE: this.updateMerchant,
                BY_DURATION: this.updateMerchant
            };

            if (this.deactivate.deactivate_setting) {
                handler[this.deactivate.deactivate_setting]();
            } else {
                handler['NOW'];
            }
        },
        updateMerchant(action) {
            let reqBody = {};

            if (action == 'activate') {
                reqBody['activate_at'] = this.activate.activate_at;
            } else {
                const deactivateData = { ...this.deactivate };
                if (deactivateData.deactivate_setting == 'BY_DURATION') delete deactivateData.deactivate_at;

                for (const [key, value] of Object.entries(deactivateData)) {
                    if (value != '' || key === 'deactivate_at') {
                        if (key === 'deactivate_at') {
                            reqBody['deactivate_at'] = value;
                            continue;
                        }
                        reqBody[key] = value;
                    }
                }
            }
            this.confirmStatusLoading = true;
            this.$store
                .dispatch('merchants/setMerchant', {
                    id: this.merchantDetails.uuid,
                    data: reqBody
                })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message || response[0] });
                    this.confirmDialog.show = false;
                    this.confirmStatusLoading = false;
                    this.fetchMerchant(response.data);
                })
                .catch(() => {
                    if (this.errors) {
                        this.confirmDialog.show = false;
                    }

                    this.confirmStatusLoading = false;
                });
        },
        sendQR() {
            this.sendQRFormDialog = { show: true, data: { id: this.merchantDetails.uuid, classification: this.merchantDetails.classification, merchantName: this.merchantDetails.name } };
        },
        downloadMerchantQR(type) {
            if (type == 'partner-branches') {
                this.$store
                    .dispatch('merchants/processDownloadAsyncMerchantBranchesQR', { id: this.merchantDetails.uuid })
                    .then((response) => {
                        // Set encoded asyncTaskIDPoll
                        this.$cookies.set('asyncTaskIDPoll', window.btoa(response.data.id));

                        let classificationModule = this.merchantDetails.classification == 'BRANCH' ? 'Branches' : 'Merchants';

                        // Set asyncTaskModule
                        this.$cookies.set('asyncTaskModule', classificationModule);

                        this.notification({
                            type: 'success',
                            title: `${classificationModule} - QR Download`,
                            message: 'QR Generation In-Progress. Please wait for the process to complete. Do not logout or close this window.'
                        });
                        this.$eventBus.$emit('check-merchants-qr-status');
                    })
                    .catch((error) => {
                        if (error.response && error.response.data) {
                            let text = [];
                            if (error.response.data.errors) {
                                let errors = Object.keys(error.response.data.errors);
                                // Loop each field with errors
                                errors.forEach((key) => {
                                    text = [...text, `${error.response.data.errors[key]} <br/>`];
                                });
                            }

                            let classificationModule = this.merchantDetails.classification == 'BRANCH' ? 'Branches' : 'Merchants';

                            this.$notify({
                                group: 'main-notifications',
                                type: 'error',
                                duration: 5000,
                                title: `${classificationModule} - QR Download`,
                                text: text.length > 0 ? text.toString().replace(',', '') : error.response.data.data.message || error.response.data.message || error.response.statusText
                            });
                        }
                    });
            } else {
                this.$store.dispatch('merchants/downloadMerchantQR', {
                    id: this.merchantDetails.uuid,
                    name: this.merchantDetails.name,
                    data: {
                        type: 'PDF',
                        partner_only: type == 'partner' ? 1 : 0
                    },
                    config: {
                        responseType: 'blob',
                        addHeader: true
                    }
                });
            }
        },
        printMerchantQR() {
            // this.$router.push({ name: 'view-merchant', params: { id: id } });
            let routeData = this.$router.resolve({ path: `/merchants/qr/${this.merchantDetails.uuid}` });
            window.open(routeData.href, '_blank');
        },
        fetchMerchant(response = false) {
            if (response) {
                this.$store.commit('merchants/SET_MERCHANT_DETAILS', response);
            } else {
                this.$store.commit('merchants/SET_MERCHANT_DETAILS', {});
            }

            this.activate = {
                activate_setting: 'NOW',
                activate_at: ''
            };

            this.deactivate = {
                deactivate_setting: 'NOW',
                deactivate_at: '',
                deactivate_duration: '',
                deactivate_duration_unit: ''
            };

            let id = this.$route.params.branch ? this.$route.params.branch : this.$route.params.id;
            if (id) {
                const config = {
                    params: { appends: ['primary_merchant', 'qr_base64'] }
                };

                this.$store.dispatch('merchants/findMerchant', { id: id, config: config }).catch(() => {
                    this.$router.push(this.navigation('back'));
                });
            } else {
                this.$store.dispatch('merchants/findMyMerchant').catch(() => {
                    this.$router.push(this.navigation('back'));
                });
            }
        },
        checkMerchantDetailsStatus(active_at, status) {
            return status === 'ACTIVE' ? false : active_at === null ? true : false;
        },
        checkDisable(menu, settings, mode) {
            let modeSetting = mode + '_setting';

            if (mode === 'activate') {
                if (settings[modeSetting] === 'NOW') {
                    return false;
                } else {
                    return settings.activate_at.length > 0 && !menu ? false : true;
                }
            } else {
                if (settings[modeSetting] === 'NOW') {
                    if (this.merchantDetails.status.toLowerCase() === 'inactive') {
                        return true;
                    } else {
                        return false;
                    }
                } else if (settings[modeSetting] === 'BY_DATE') {
                    return settings.deactivate_at.length > 0 && !menu ? false : true;
                } else {
                    return settings.deactivate_duration > 0 && settings.deactivate_duration_unit && !menu ? false : true;
                }
            }
        }
    }
};
</script>

<style>
.disable-events {
    pointer-events: none;
    opacity: 0.75;
}

.success-1 {
    color: #27ae60;
    background-color: #e1f7ea;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
